import { socketEvents } from './events';
import { SocketSetValueType } from '../types';

type Props = SocketSetValueType;

export const initSockets = ({ setValue }: Props): void => {
    // 'setValue' is passed on to be used by socketEvents
    socketEvents({ setValue });
};
